
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getOnboardingContext",
      resolverType: "query",
      routePath: "/getOnboardingContext",
      httpMethod: "POST",
    });
  